<template>
  <div class="app-planning">
    <div class="columns">
      <div class="column is-one-quarter">
        <div class="buttons has-addons">
          <span v-for="duree in dureeAffichage" :key="duree.dureeEnMois"
                class="button"
                :class="{ 'is-primary': criterePlanning.months === duree.dureeEnMois }"
                @click="updateDureeEnMois(duree.dureeEnMois)">
            {{ duree.label }}
          </span>
        </div>
      </div>
      <div class="column is-half has-text-centered">
        <div>
          <button class="button" @click="updateDateDebut(-criterePlanning.months)">
            <b-icon icon="chevron-double-left"></b-icon>
          </button>
          <button class="button" @click="updateDateDebut(-1)">
            <b-icon icon="chevron-left"></b-icon>
          </button>
          <span style="min-width: 290px;display: inline-block;">
        {{ dateDebutFormattee }} - {{ dateFinFormattee }}
        </span>
          <button class="button" @click="updateDateDebut(1)">
            <b-icon icon="chevron-right"></b-icon>
          </button>
          <button class="button" @click="updateDateDebut(criterePlanning.months)">
            <b-icon icon="chevron-double-right"></b-icon>
          </button>
        </div>
      </div>
      <div class="column is-one-quarter">
        <div class="is-pulled-right">
          <a class="button" @click="getPlaningPdf()">
            <b-icon icon="printer" ></b-icon>
            <span class="ellipsis btn_consultation">Imprimer</span>
          </a>
        </div>
      </div>
    </div>
    <v-client-table class="fixed_header" ref="planning"
                    :data="data"
                    :columns="columns"
                    :options="options">
      <div slot="selected" slot-scope="props" style="text-align:center">
        <input type="checkbox" id="checkbox" :value="props.row" v-model="props.row.selected"
               @click="ajoutPanier(props.row)">
      </div>
    </v-client-table>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { TEXTS, PER_PAGE_VALUE } from '@/configuration/clientTableConf';
import trierFaces from '@/services/catalogue/trierFaces';
import faceSelectedInitialise from '@/services/catalogue/faceSelectedInitializer';
import gestionErreur from '@/services/general/gestionErreur';
import PlanningSvg from './planningSvg';

const VenteFacesLc = createNamespacedHelpers('venteFacesLc');
const Panier = createNamespacedHelpers('panier');
const User = createNamespacedHelpers('user');

export default {
  name: 'planning',
  data() {
    return {
      dureeAffichage: [
        { dureeEnMois: 3, label: '3 mois' },
        { dureeEnMois: 6, label: '6 mois' },
        { dureeEnMois: 12, label: '12 mois' },
      ],
      trad: {
        selected: '',
        PanCode: '↑↓ Panneau',
        FacCode: '↑↓ Face',
        Adresse: '↑↓ Adresse',
        Ville: '↑↓ Ville',
        Planning: 'Planning',
      },
    };
  },
  components: {
    appPlanningSvg: PlanningSvg,
  },
  computed: {
    ...VenteFacesLc.mapGetters({
      panneauxLcWithFilter: 'panneauxLcWithFilter',
      criterePlanning: 'criterePlanning',
    }),
    ...Panier.mapGetters({
      panneauxLcPanier: 'panneauxLcPanier',
    }),
    ...User.mapGetters({
      site: 'site',
    }),
    data() {
      const faces = [];
      const panneaux = this.panneauxLcWithFilter;
      panneaux.forEach(panneau => {
        panneau.faces.forEach(face => {
          // On fait un vrai clone
          const newFace = Object.assign({}, face);
          newFace.panCode = panneau.code;
          newFace.panNum = panneau.num;
          newFace.facNum = face.facNum;
          newFace.adresse = panneau.adresseCommercialeLibelle1;
          newFace.ville = panneau.ville;
          newFace.codeDepartement = panneau.codeDepartement;
          faces.push(newFace);
        });
      });
      faceSelectedInitialise(faces, this.panneauxLcPanier);
      return trierFaces(faces);
    },
    dateDebutFormattee() {
      return this.criterePlanning.dateStart.format('LL');
    },
    dateFinFormattee() {
      return this.criterePlanning.dateEnd.format('LL');
    },
    columns() {
      return ['selected', 'panCode', 'facCode', 'adresse', 'ville', 'planning'];
    },
    options() {
      return {
        headings: {
          selected: this.trad.selected,
          panCode: this.trad.PanCode,
          facCode: this.trad.FacCode,
          adresse: this.trad.Adresse,
          ville: this.trad.Ville,
          planning(h) {
            return this.getPlanningHeader(h);
          },
        },
        filterable: false,
        perPageValues: PER_PAGE_VALUE,
        perPage: 500,
        texts: TEXTS,
        templates: {
          planning: PlanningSvg,
        },
        columnsClasses: {
          facCode: 'ellipsis ventesLcPlanningTailleColonneCode',
          panCode: 'ellipsis ventesLcPlanningTailleColonneCode',
          adresse: 'ellipsis ventesLcPlanningTailleColonneAdresse',
          planning: 'ventesLcPlanningTailleColonnePlanning',
          ville: 'ellipsis ventesLcPlanningTailleColonneVille',
          selected: 'ventesLcPlanningTailleColonneSelected',
        },
      };
    },
  },
  methods: {
    ...VenteFacesLc.mapActions({
      actionsChangementDateDebutPlanningLc: 'changementDateDebutPlanningLc',
      actionsGestionPanier: 'gestionPanier',
      actionsGetPlanningPdf: 'getPlanningPdf',
    }),
    updateDureeEnMois(duree) {
      this.actionsChangementDateDebutPlanningLc(
        {
          debut: this.criterePlanning.dateStart,
          nombreMois: duree,
        },
      );
    },
    updateDateDebut(decalage) {
      this.actionsChangementDateDebutPlanningLc(
        {
          debut: this.criterePlanning.dateStart.clone().add(decalage, 'M'),
          nombreMois: this.criterePlanning.months,
        },
      );
    },
    getPlanningHeader(h) {
      return h('svg', {
        attrs: {
          width: '100%',
          height: '28px',
        },
      },
      this.getPlanningHeaderMois(h));
    },
    getPlanningHeaderMois(h) {
      const lineAndTextArray = [];
      const nombreJoursTotal = this.criterePlanning.days;
      const dateStart = this.criterePlanning.dateStart;
      const dateEnd = this.criterePlanning.dateEnd;
      let dateVar = dateStart.clone();
      while (dateVar < dateEnd) {
        const offset = dateVar.diff(dateStart, 'days') / nombreJoursTotal * 100;
        if (!dateVar.isSame(dateStart)) {
          lineAndTextArray.push(h('line', {
            attrs: {
              x1: offset + '%',
              y1: '0',
              x2: offset + '%',
              y2: '80%',
              style: 'stroke: #E3E1F2;stroke-width: 2px',
            },
          }));
        }
        lineAndTextArray.push(h('text', {
          attrs: {
            x: (offset + 0.5) + '%',
            y: '50%',
            'dominant-baseline': 'central',
            'text-anchor': 'start',
            'font-size': '12px',
          },
        }, dateVar.format('MMM')));
        dateVar = dateVar.add(1, 'M');
      }
      return lineAndTextArray;
    },
    ajoutPanier(f) {
      this.actionsGestionPanier({ face: f });
    },
    async getPlaningPdf() {
      const loadingComponent = this.$buefy.loading.open({ container: null });
      try {
        let panNum = this.$refs.planning.filteredData.map(el => el.facNum);
        if (this.site === 'alfa') {
          panNum = this.$refs.planning.filteredData
            .sort((a, b) => {
              if (!a.ville || !b.ville || !a.facCode || !b.facCode) return 0;
              return a.ville.localeCompare(b.ville) || a.facCode.localeCompare(b.facCode);
            })
            .map(el => el.facNum);
        }
        await this.actionsGetPlanningPdf(panNum);
        loadingComponent.close();
        return true;
      } catch (e) {
        gestionErreur(e.message, e);
        loadingComponent.close();
        return false;
      }
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/creationOpportunite/venteFacesLc/recherche/planning.vue